/* DIS/PLAY Script
 Author's name: Lars Munkholm <lar@dis-play.dk>
 Modified by: Anders Gissel <agi@dis-play.dk>
 Client name:
 Date of creation:
 */

import { currentWindowScrollPositionX, currentWindowScrollPositionY } from './onScroll';
import triggerCustomEvent from './triggerCustomEvent';


let className = "dis-scroll-lock";
let scrollTop = 0;


/**
 * Get the current state of the scroll lock.
 *
 * @type {boolean}
 */
export let currentState = false;


/**
 * Enable the scroll lock.
 */
export function enable() {
    if (!currentState) {
        // Get scroll position
        scrollTop = currentWindowScrollPositionY;

        // Reset scroll position
        window.scrollTo(currentWindowScrollPositionX, 0);

        let htmlTag = document.documentElement;
        htmlTag.classList.add(className);
        htmlTag.style.marginTop = (-scrollTop) + "px";
        htmlTag.style.position = "fixed";
        htmlTag.style.overflow = "hidden";
        htmlTag.style.width = "100%";

        // Trigger event on target. You can listen for it using document.body.addEventListener("dis.scrolllock:enable", callbackHere)
        triggerCustomEvent(document.body, "dis.scrolllock:enable");

        // Remember state
        currentState = true;
    }
}


/**
 * Disable the scroll lock
 */
export function disable() {
    if (currentState) {

        let htmlTag = document.documentElement;
        htmlTag.classList.remove(className);
        htmlTag.style.marginTop = "";
        htmlTag.style.position = "";
        htmlTag.style.overflow = "";
        htmlTag.style.width = "";

        // Set the scroll position to what it was before
        window.scrollTo(currentWindowScrollPositionX, scrollTop);

        // Trigger event on target. You can listen for it using document.body.addEventListener("dis.scrolllock:disable", callbackHere)
        triggerCustomEvent(document.body, "dis.scrolllock:disable");

        // Remember state
        currentState = false;
    }
}


/**
 * Toggle the scroll lock between on and off
 */
export function toggle() {
    if (currentState) {
        disable();
    } else {
        enable();
    }
}


/**
 * Default object containing all regular methods
 */
export default {
    enable,
    disable,
    toggle
};
